import React from 'react'
import styled from 'styled-components'
import NoSsr from '@material-ui/core/NoSsr'
import { createMuiTheme } from '@material-ui/core/styles'
import { palette, spacing, typography } from '@material-ui/system'

const Box = styled.div`
  ${palette}${spacing}${typography}
`
// or import Box from '@material-ui/core/Box';

export default function CustomBox(props) {
  return (
    <NoSsr>
        <Box color="primary.main" bgcolor="background.paper" {...props}>
          {props.children}
        </Box>
    </NoSsr>
  )
}
